require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-use-export-to-reuse-a-code-block.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-use-export-to-reuse-a-code-block");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-use-export-to-reuse-a-code-block!./.cache/json/javascript-algorithms-and-data-structures-es-6-use-export-to-reuse-a-code-block.json
// module id = 2379
// module chunks = 231608221292675